import withHistory from 'hoc/withHistory';

// Circular dependencies https://warrenpay.atlassian.net/browse/ARCH-181
// eslint-disable-next-line import/no-cycle
import InvalidFundingAccountHint from './InvalidFundingAccountHint';

export default withHistory(InvalidFundingAccountHint);
